import { ShieldCheck, Wrench, FileCheck, DollarSign, Award } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export function TrustBar({ dark = false }: { dark?: boolean }) {
  const items = [
    { Icon: ShieldCheck, label: "AZ ROC Licensed, Bonded & Insured" },
    { Icon: Wrench, label: `Family-Owned Since ${BUSINESS.founded}` },
    { Icon: DollarSign, label: "Upfront Flat-Rate Pricing" },
    { Icon: FileCheck, label: "Written Workmanship Warranty" },
    { Icon: Award, label: "Local Phoenix Plumbers" },
  ];
  return (
    <ul
      className={
        "flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold " +
        (dark ? "text-secondary-foreground/90" : "text-secondary")
      }
    >
      {items.map(({ Icon, label }) => (
        <li key={label} className="inline-flex items-center gap-1.5">
          <Icon className="h-4 w-4 text-accent" aria-hidden />
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
}